import { styled } from 'styled-components';

export const ListingViewMainHolder = styled.div`
  flex: 1;
  padding-top: 32px;
`;
